import type { SelectHTMLAttributes } from 'react';
import { cn } from './cn';

export const Select = ({
  className,
  children,
  ...props
}: SelectHTMLAttributes<HTMLSelectElement>) => (
  <div className="relative flex content-center text-xs transition-all text-text">
    <select
      className={cn(
        'relative block w-full cursor-pointer appearance-none rounded-control border border-border/40 bg-white/85 py-3 pl-3.5 pr-8 text-xs font-medium text-text outline-none hover:border-text/40 hover:bg-white focus:border-text focus:ring-2 focus:ring-accent/35 disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      {...props}
    >
      {children}
    </select>
    <svg
      className="absolute w-3 h-3 pointer-events-none stroke-muted top-4 right-3"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.30859 1.38867L6.85208 6.93184L12.3953 1.38867"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);
